import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  action_button: {
    backgroundColor: palette.primary.light,
    borderRadius: "50%",
    color: palette.primary.main,
    height: spacing(5),
    marginRight: spacing(1.5),
    width: spacing(5),
  },

  container: {
    overflow: "auto",
    width: "100%",
  },

  dialog: {
    "& ::-webkit-scrollbar": { display: "none" },
    "-ms-overflow-style": "none",
    marginBottom: spacing(-4),
    overflow: "hidden",
    padding: 0,
  },

  dialog__content: {
    display: "flex",
    height: "100%",
    overflow: "hidden",
    padding: "60px 32px 0",
  },

  dialog__paper: {
    maxWidth: 1100,
    overflow: "hidden",
    padding: 0,
  },

  dialog__title: {
    padding: 0,
  },

  editButton: {
    marginRight: spacing(1.5),
  },

  header: {
    position: "relative",
    zIndex: 1,
  },

  info: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  info__user: {
    alignItems: "center",
    display: "flex",
  },

  info__user__icn: {
    alignItems: "center",
    border: "1px solid #E0E2E6",
    borderRadius: 12,
    display: "flex",
    fontSize: 12,
    height: 24,
    justifyContent: "center",
    marginRight: 14,
    width: 24,
  },

  info__user__text: {},

  masonry: {
    boxSizing: "border-box",
    maxWidth: 960,
    overflow: "hidden",
    paddingTop: spacing(0.5),
    width: "100%",
  },

  preview: {
    alignItems: "center",
    aspectRatio: "1/1",
    backgroundColor: palette.primary.light,
    display: "flex",
    justifyContent: "center",
    padding: spacing(2),
    width: "100%",

    [breakpoints.down("sm")]: {
      maxHeight: "45vh",
    },
  },

  preview__image: {
    borderRadius: spacing(0.5),
    height: "100%",
    objectFit: "contain",
    width: "100%",
  },
}));
